import { useCart } from "@shopify/hydrogen";
import { translate } from "@locales";
import { CloseIcon } from "@components/atoms/Icons";

interface Props {
  onclose: () => void;
}

export function HeaderCart({ onclose }: Props) {
  const { totalQuantity } = useCart();
  return (
    <header className="sticky top-0 flex items-center justify-between w-full h-[65px] lg:h-24 bg-[#F8F8F8] px-5 lg:px-[38px]">
      <h2
        id="cart-contents"
        className="whitespace-pre-wrap max-w-prose font-medium uppercase text-custom-black text-[15px] lg:text-lg"
      >
        ({totalQuantity}) {translate("shop.cart.items")}
      </h2>
      <button
        type="button"
        className="transition text-primary hover:text-primary/50"
        onClick={onclose}
      >
        <CloseIcon aria-label="Close panel" width="24" height="24" />
      </button>
    </header>
  );
}
